import * as angular from "angular";
import {IController} from "angular";

export class notificationTypeStatusCtrl implements IController {

  type: any;

  /* @ngInject */
  constructor() {
  }

}

angular
  .module('bringoz.admin.notifications')
  .component('notificationTypeStatus', {
    bindings: {
      type: '<'
    },
    template: require('./notification-type-status.html').default,
    controller: notificationTypeStatusCtrl
  });
